import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaGlobe,
  FaUsers,
  FaChartLine,
  FaFileAlt,
  FaMobileAlt,
  FaShieldAlt,
  FaRocket,
  FaCheckCircle,
  FaStar,
  FaArrowRight,
  FaBuilding,
  FaMoneyBillWave,
  FaHandshake,
  FaSearch,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaBell,
  FaLock,
  FaDatabase,
  FaCode,
} from "react-icons/fa";
import "./KasaWebPage.css";

const KasaWebPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Modal state management
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const galleryImages = [
    '/kasaweb/ukazka1.png',
    '/kasaweb/ukazka2.png',
    '/kasaweb/ukazka3.png'
  ];

  const openModal = (imageSrc) => {
    const index = galleryImages.indexOf(imageSrc);
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const features = [
    {
      icon: FaGlobe,
      title: "Responzívny dizajn",
      description:
        "Webová stránka prispôsobená pre všetky zariadenia - od mobilov cez tablety až po desktopy",
    },
    {
      icon: FaMoneyBillWave,
      title: "Prezentácia pohľadávok",
      description:
        "Prehľadný systém pre zobrazenie a správu ponúkaných pohľadávok pre zákazníkov",
    },
    {
      icon: FaBell,
      title: "Real-time notifikácie",
      description:
        "SignalR integrácia pre okamžité aktualizácie a notifikácie o nových ponukách",
    },
    {
      icon: FaLock,
      title: "Bezpečnosť údajov",
      description:
        "Vysoká úroveň zabezpečenia osobných a finančných údajov zákazníkov",
    },
    {
      icon: FaSearch,
      title: "Vyhľadávanie a filtrovanie",
      description:
        "Pokročilé možnosti vyhľadávania a filtrovania pohľadávok podľa rôznych kritérií",
    },
    {
      icon: FaHandshake,
      title: "Kontaktný formulár",
      description:
        "Jednoduchý a prehľadný systém pre komunikáciu so zákazníkmi a získavanie dopytov",
    },
  ];

  const technologies = [
    {
      name: 'React',
      description: 'Frontend framework',
      color: '#61DAFB'
    },
    {
      name: 'C#',
      description: 'Backend API',
      color: '#239120'
    },
    {
      name: 'MSSQL',
      description: 'Databázový systém',
      color: '#cc2927'
    },
    {
      name: 'SignalR',
      description: 'Real-time komunikácia',
      color: '#512BD4'
    },
    {
      name: 'MUI',
      description: 'UI komponentová knižnica',
      color: '#007FFF'
    }
  ];

  const benefits = [
    {
      icon: FaRocket,
      title: "Výkon stránky",
      value: "2x rýchlejšia",
      description: "Optimalizovaný kód a moderné technológie pre rýchle načítanie a plynulý zážitok",
    },
    {
      icon: FaMobileAlt,
      title: "Dynamické zobrazenie pohľadávok",
      value: "100%",
      description: "Aktuálne ponuky zobrazené v reálnom čase",
    },
    {
      icon: FaCheckCircle,
      title: "Dostupnosť",
      value: "99.9%",
      description: "Garantovaná dostupnosť webovej stránky",
    },
    {
      icon: FaUsers,
      title: "Pohľadávky zobrazené zákazníkom",
      value: "80%",
      description: "Lepšia filtrácia a prezentácia ponúk pre zvýšenie záujmu zákazníkov",
    },
    {
        icon: FaFileAlt,
        title: "Škálovateľnosť stránky",
        value: "99.9%",
        description: "Riešenie navrhnuté s ohľadom na budúci rast a rozšírenie funkcionality",
    }
  ];

  const industries = [
    {
      icon: FaBuilding,
      title: "Finančné služby",
      description:
        "Ideálne riešenie pre záložne a spoločnosti poskytujúce finančné služby",
    },
    {
      icon: FaDatabase,
      title: "Správa pohľadávok",
      description: "Systém pre efektívnu prezentáciu a správu pohľadávok online",
    },
    {
      icon: FaCode,
      title: "Moderné technológie",
      description:
        "Postavené na najnovších webových technológiách pre maximálny výkon",
    },
    {
      icon: FaShieldAlt,
      title: "GDPR compliance",
      description:
        "Plný súlad s nariadením GDPR a ochrana osobných údajov",
    },
  ];

  const testimonials = [
    {
      name: "Mgr. Jana Horváthová",
      company: "KASA ZÁLOŽNÁ a.s.",
      text: "Nová webová stránka výrazne zlepšila našu online prezentáciu. Zákazníci si pochvaľujú prehľadnosť a jednoduchosť vyhľadávania ponúkaných pohľadávok.",
      rating: 5,
    },
    {
      name: "Ing. Martin Szabó",
      company: "KASA ZÁLOŽNÁ a.s.",
      text: "Real-time aktualizácie a moderný dizajn priniesli značný nárast záujmu zo strany zákazníkov. Spolupráca s tímom bola profesionálna.",
      rating: 5,
    },
  ];

  return (
    <div className="kasaweb-page">
      {/* Hero Section */}
      <section className="kasaweb-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>KASA ZÁLOŽNÁ Web</h1>
              <h2>Webová stránka pre KASA ZÁLOŽNÁ akciová spoločnosť</h2>
              <p>
                Moderná a responzívna webová stránka vytvorená pre spoločnosť 
                KASA ZÁLOŽNÁ akciová spoločnosť. Stránka prezentuje služby 
                spoločnosti, poskytuje prehľad ponúkaných pohľadávok a umožňuje 
                jednoduchý kontakt so zákazníkmi. Riešenie je postavené na 
                moderných technológiách s dôrazom na výkon, bezpečnosť a 
                kvalitnú používateľskú skúsenosť.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/kasaweb.jpg" alt="KASA ZÁLOŽNÁ webová stránka" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Ukážky webstránky</h2>
          <div className="gallery-grid">
            <div className="gallery-item" onClick={() => openModal('/kasaweb/ukazka1.png')}>
              <img src="/kasaweb/ukazka1.png" alt="KASA ZÁLOŽNÁ web - ukážka 1" />
            </div>
            <div className="gallery-item" onClick={() => openModal('/kasaweb/ukazka2.png')}>
              <img src="/kasaweb/ukazka2.png" alt="KASA ZÁLOŽNÁ web - ukážka 2" />
            </div>
            <div className="gallery-item" onClick={() => openModal('/kasaweb/ukazka3.png')}>
              <img src="/kasaweb/ukazka3.png" alt="KASA ZÁLOŽNÁ web - ukážka 3" />
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <div className="container">
          <h2>Použité technológie</h2>
          <div className="technologies-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="technology-card">
                <div className="tech-name" style={{ color: tech.color }}>
                  {tech.name}
                </div>
                <p>{tech.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Kľúčové funkcie</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Merateľné výsledky</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section
      <section className="industries-section">
        <div className="container">
          <h2>Charakteristika riešenia</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Testimonials Section */}
      {/* <section className="testimonials-section">
        <div className="container">
          <h2>Čo hovoria naši klienti</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <p>"{testimonial.text}"</p>
                  <div className="testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
                <div className="testimonial-author">
                  <h5>{testimonial.name}</h5>
                  <span>{testimonial.company}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Customer Section */}
      <section className="customers-section">
        <div className="container">
          <h2>Náš klient</h2>
          <div className="customers-grid">
            <a 
              href="https://www.kasa.sk/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="customer-card"
            >
              <img src="/kasa.jpg" alt="Kasa" />
              <h3>KASA ZÁLOŽNÁ a.s.</h3>
              <p>KASA ZÁLOŽNÁ a.s. je jednou z najväčších spoločností na Slovensku, poskytujúcich peňažnú hotovosť formou záložného práva.</p>
            </a>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <button className="modal-prev" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <img 
              src={galleryImages[currentImageIndex]} 
              alt={`KASA ZÁLOŽNÁ web - ukážka ${currentImageIndex + 1}`}
            />
            <button className="modal-next" onClick={nextImage}>
              <FaChevronRight />
            </button>
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KasaWebPage;
